import styled from 'styled-components';
import {BGImageCenter} from '../../../../../../globalVariables/GlobalVariables';
import {getSpacing, getToken, getFontSize, getPrimitive, tokens, responsive} from '@tickchak/react-share/app';
import {dFlex, flexColumn, alignEnd, justifyCenter, alignCenter} from '../../../../../../globalVariables/GlobalFlex';
import {wrap} from '../../../../../../component/textEditor/TextEditor.css.js';

interface ImageProps {
    image?: string;
}

export const section = styled.div`
    ${dFlex}
    ${flexColumn}
    ${alignEnd}
    gap: ${getSpacing('spaceLg', 'desktop')};
    align-self: stretch;
`;

export const imageWrapper = styled.div`
    background: ${getPrimitive('turquoise.turquoise200')};
    border-radius: 10px;
    width: 100%;
    ${dFlex}
    ${justifyCenter}
    position: relative;
    margin-bottom: ${getSpacing('spaceLg', 'desktop')};
    margin-top: ${getSpacing('spaceSm', 'desktop')};
`;

export const image = styled.div<ImageProps>`
    position: absolute;
    border-radius: 10px;
    width: 240px;
    height: 100%;
    ${p => BGImageCenter(p.image, 'cover')}
`;

export const editorWrapper = styled.div`
    ${wrap}{
        width: 100%;
        inset-inline-start: 0;
    }
    .ql-toolbar.ql-snow{
        border-bottom: none;
        border-top: 1px solid ${getPrimitive('grays.gray200')};
    }
    padding-block: ${getSpacing('spaceLg', 'desktop')};
    width: 100%;
    ${dFlex}
    padding: ${getSpacing('space2xl', 'desktop')} ${getSpacing('spaceXl', 'desktop')};
    ${flexColumn}
    ${justifyCenter}
    ${alignCenter}
    gap: ${getSpacing('space2xl', 'desktop')};
    align-self: stretch;
    border-radius: 10px;
    border: 2px solid ${getToken('color.brand.main')};
    background: ${getToken('color.bg.base')};
    position: relative;
`;
export const editorTitle = styled.div`
    ${dFlex}
    ${alignCenter}
    gap: 6px;
    position: absolute;
    inset-inline-start: ${getSpacing('spaceLg', 'desktop')};
    top: -18px;
    border-radius: 100px;
    background: ${getToken('color.bg.base')};
    ${responsive(getFontSize('caption'), 'font-size')};
    padding: ${getSpacing('spaceSm', 'desktop')};
    ${responsive(getSpacing('spaceXl', 'desktop'), 'padding-inline-start')};
    &::before{
        content: '';
        position: absolute;
        top: 43%;
        inset-inline-start: ${getSpacing('spaceSm', 'desktop')};
        width: 8px;
        height: 8px;
        border-radius: 2px;
        background: ${getToken('color.brand.main')};
    }
`;

